import { render } from "./DgWohnungStep6.vue?vue&type=template&id=211033a4&scoped=true"
import script from "./DgWohnungStep6.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep6.vue?vue&type=script&lang=js"

import "./DgWohnungStep6.vue?vue&type=style&index=0&id=211033a4&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211033a4"]])

export default __exports__